module.exports = __webpack_public_path__ + "static/outline-e32e7e044a6061cf8961117dc8e3a657.png";